import {BadgeProps, ButtonProps} from '@mantine/core';

export enum HomepagePreferences {
  SHOW_NEW_HOMEPAGE = 'SHOW_NEW_HOMEPAGE',
}

export const HOMEPAGE_PATH = '/editor/homepage';

export const HOMEPAGE_SECTION_TEST_COMPONENT = {
  ACTIVITY: 'ActivitySection',
  RECENTS: 'RecentsSection',
  WORKLISTS: 'WorklistsSection',
  MY_WORK: 'MyWorkSection',
  AI: 'AISection',
  WELCOME: 'WelcomeSection',
} as const;

export const INITIAL_ROWS_TO_DISPLAY = 10;
export const LOADING_SKELETON_ROW_COUNT = INITIAL_ROWS_TO_DISPLAY / 2;
export const MAX_ROWS_TO_DISPLAY = 25;

export const DEFAULT_BADGE_PROPS: BadgeProps = {
  size: 'sm',
  radius: 'xl',
};

export const DEFAULT_SECTION_BUTTON_PROPS: ButtonProps = {
  variant: 'default',
  size: 'md',
  radius: 'lg',
  fw: 500,
};

const COLUMN_SPACING_INT = 26;
export const COLUMN_SPACING = `${COLUMN_SPACING_INT}px`;
const MAX_COLUMN_WIDTH = 640;
export const MAX_CONTENT_WIDTH = MAX_COLUMN_WIDTH * 2 + COLUMN_SPACING_INT;

/** Below this width, card section rows use a compact layout. */
export const COMPACT_CARD_SECTION_MAX_WIDTH = 450;

/** Below this width, homepage cards stack in a single column. */
export const SINGLE_COLUMN_MODE_MAX_WIDTH = 800;
